var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-pagination-nav',{attrs:{"link-gen":_vm.linkGen,"number-of-pages":_vm.pageTotal,"use-router":""},on:{"page-click":_vm.changeRoute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }